var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileDefaultLtr = function SvgProfileDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M49.5 0C64.135 0 76 11.865 76 26.5S64.135 53 49.5 53 23 41.136 23 26.5 34.865 0 49.5 0m0 5.972c-11.337 0-20.528 9.19-20.528 20.528s9.19 20.529 20.528 20.529c11.224 0 20.344-9.008 20.526-20.19l.002-.339-.002-.34C69.845 14.98 60.724 5.973 49.5 5.973",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.905 96.3C94.09 73.92 73.647 58 50 58S5.91 73.92.095 96.3a2.96 2.96 0 0 0 2.148 3.606c1.597.408 3.226-.546 3.637-2.129C11.02 77.997 29.095 63.921 50 63.921s38.98 14.075 44.12 33.856c.411 1.584 2.04 2.536 3.637 2.129a2.96 2.96 0 0 0 2.148-3.606"
  })));
};
export default SvgProfileDefaultLtr;